export default "__VITE_ASSET__008c1a05__"